<template>
<div class="swipers nark">
	<div class="swiper mySwiper lqs">
		<div class="swiper-wrapper">
			<!-- <div class="swiper-slide" v-for="item in banner" :key="item.id"><img :src="Http+item.image" class="banone"></div> -->
			<div class="swiper-slide" v-for="item in banner" :key="item.id"><img src="./img/banner-1.jpg" class="banone"></div>
		</div>
		<div class="swiper-pagination"></div>
	</div>
</div>
</template>
 
<script>
import{mapState} from 'vuex'
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
	name: 'SwiperBanner',
	data () {
		return {}
	},
	mounted() {
		new Swiper(".mySwiper", {
				pagination: {
					el: ".swiper-pagination",
				},
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
		});
	},	
	computed:{
		...mapState({
			banner:state=>state.share.banner,
			Http:state=>state.share.Http
		})
	}
}
</script>
<style  scoped>
	.swipers {
		overflow: hidden;
		position: relative;
		min-height: 488px;
	}
	.swiper img{
		width: 100%;
	}
	@media (max-width: 768px){
		.swipers{
			min-height: auto;
		}
	}
</style>